/**PROPS**
 * title = "string"
 * checked = true / false
 * id = for outside click id
 */

import React from 'react';
import styled from 'styled-components';

import IconsLib from '@/utils/IconsLib';
import { colors } from '@/constants/colors';

interface Props {
   id?: string;
   title?: string;
   checked: boolean;
   colorText?: string;
   bg?: string;
   enable?: boolean;
}

const CheckboxSingle = ({
   id,
   title,
   checked,
   colorText,
   bg,
   enable,
}: Props) => {
   return (
      <Wrapper className="checkbox-single" id={id}>
         <IconWrapper
            active={checked}
            bg={bg ?? ''}
            id={id}
            enable={enable ?? false}
            className={`checkbox-single__iconWrapper${
               checked ? '--active' : ''
            }`}
         >
            <IconsLib icon="sample" color="white" size="16px" id={id} />
         </IconWrapper>
         <Title
            colorText={colorText ?? ''}
            id={id}
            className="checkbox-single__title"
         >
            {title}
         </Title>
      </Wrapper>
   );
};

const Wrapper = styled.div`
   user-select: none;
   display: flex;
   gap: 10px;
   align-items: center;
   cursor: pointer;
`;

const IconWrapper = styled.div<{
   active: boolean;
   enable: boolean;
   bg: string;
}>`
   border: ${({ active, bg, enable }) =>
      active && !bg
         ? `2px solid ${colors.PRIMARY}`
         : active && bg
         ? bg
         : !enable
         ? `2px solid ${colors.GRAY10}`
         : `2px solid ${colors.GRAY4}`};
   border-radius: 5px;
   width: 20px;
   height: 20px;
   display: grid;
   place-items: center;

   background-color: ${({ active, bg }) =>
      active && !bg ? `${colors.PRIMARY}` : active && bg ? `${bg}` : 'white'};
`;

const Title = styled.p<{ colorText: string }>`
   font-size: 14px;
   margin-bottom: 0;
   text-decoration: capitalize;
   color: ${({ colorText }) => (colorText ? colorText : 'black')};
`;

export default CheckboxSingle;
